import Organizations from "api/lib/data/Organizations";
import AddUserToOrgObject from "api/lib/data/interfaces/AddUserToOrgObject";
import * as _ from "lodash";
import * as React from "react";
import * as routes from "../../constants/routes";

import {
  IBaseProps,
  Base,
  IBaseState,
  Event,
} from "src/components/Common/Base";
import { Header } from "semantic-ui-react";
import { Redirect } from "react-router-dom";
export interface IWelcomeProps extends IBaseProps {
  history: any;
  match: any;
  onSetWelcomeMsg: (show: boolean) => void;
}

export interface IWelcomeState extends IBaseState {
  success: boolean;
  waiting: boolean;
  errorMsg: string;
}
export default class Welcome extends Base<IWelcomeProps, IWelcomeState> {
  private static INITAL_STATE = {
    ...Base.BASE_INITAL_STATE,
  };

  constructor(props: IWelcomeProps) {
    super(props);

    this.state = {
      ...Welcome.INITAL_STATE,
      success: false,
      waiting: true,
      errorMsg: "",
    };
  }

  public render() {
    const { success, waiting, errorMsg } = this.state;
    if (!waiting && success) {
      return <Redirect to={routes.HOME(this.props.orgId)} />;
    }
    return (
      <React.Fragment>
        {!waiting && success && <Header as="h1">Successfully</Header>}
        {!waiting && !success && (
          <Header as="h1">Failed to Join: {errorMsg ? errorMsg : ""}</Header>
        )}
      </React.Fragment>
    );
  }
  public componentDidMount = () => {
    this.getData();
  };

  private getData = () => {
    const { authUser, orgId, match, onSetWelcomeMsg } = this.props;
    const orgs = new Organizations();
    const inviteUserReq: AddUserToOrgObject = {
      audit: {
        createdBy: authUser.uid,
      },
      request: {
        audit: {
          createdBy: authUser.uid,
        },
        invitationCode: match.params.invitationCode,
      },
    };
    orgs
      .addUserToOrg(orgId, authUser.uid, inviteUserReq)
      .then((requestRef: firebase.database.Reference) => {
        this.getListner(
          orgs.getApiResponse(orgId, authUser.uid, requestRef.key),
          Event.Value,
          (snapshot: firebase.database.DataSnapshot) => {
            const resp = snapshot.val();
            if (resp && resp.headers) {
              let success: boolean;
              const waiting: boolean = false;
              if (resp.headers.statusCode === 200) {
                success = true;
              } else {
                success = false;
              }
              onSetWelcomeMsg(success);
              this.setState({ waiting, success, errorMsg: resp.headers.msg });
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
        this.setState({ waiting: false, success: false });
      });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Join/Welcome.tsx